import { Navigate, Routes } from 'react-router-dom';
import { Box } from '@mui/material';

import { Page } from '@occc-app/design-system';
import { Tab, Tabs } from '@occc/ui-design-system';
import { SentryRoute as Route } from '@occc-app/App/sentry';

import RetailerNetworkConfigurationForm from '../retailer-network-configuration/retailer-network-configuration.component';
import { RetailerNetworkConfigurationFormProps } from '../retailer-network-configuration/retailer-network-configuration.types';
import { RetailerNetworkConfigurationTabs } from '../retailer-connect.types';
import { routeCreator, getTabItems } from '../retailer-connect.utils';

const PAGE_TITLE = 'Network Configuration';

const tabItems = getTabItems(true);

type RetailerNetworkCreatePageProps = {
  tabValue: RetailerNetworkConfigurationTabs;
  retailerNetworkCreate: RetailerNetworkConfigurationFormProps['onSubmit'];
};

export const RetailerNetworkCreatePage = ({
  tabValue,
  retailerNetworkCreate,
}: RetailerNetworkCreatePageProps) => {
  return (
    <Page
      browserTabTitle={PAGE_TITLE}
      pageHeaderProps={{ title: PAGE_TITLE }}
      containerProps={{ variant: 'md' }}
    >
      <Box ml={2}>
        <Tabs
          variant='scrollable'
          scrollButtons='auto'
          indicatorColor='secondary'
          textColor='secondary'
          value={tabValue}
        >
          {tabItems.map((item) => (
            <Tab key={item.value} value={item.value} label={item.label} disabled={item.disabled} />
          ))}
        </Tabs>
      </Box>
      <Routes>
        <Route
          path='/details' // TODO find a better way to describe route paths
          element={<RetailerNetworkConfigurationForm onSubmit={retailerNetworkCreate} />}
        />
        <Route
          key='default'
          path=''
          element={<Navigate to={routeCreator.configurationNetworkDetails} replace />}
        />
      </Routes>
    </Page>
  );
};
